module.exports = __webpack_public_path__ + "img/3-plaque-rue.1d6f75b7.png";